import angular from 'angular';

import { UploadDocumentosEmLoteIndexController } from './index/upload-documentos-em-lote.index.controller';
import { UploadDocumentosEmLoteNewController } from './new/upload-documentos-em-lote.new.controller';
import { UploadDocumentosEmLoteShowController } from './show/upload-documentos-em-lote.show.controller';

import { DadosDoDocumentoFormComponent } from './new/form/dados-do-documento/dados-do-documento.form.component';
import { SelecaoDeColaboradoresUploadLoteFormComponent } from './new/form/selecao-de-colaboradores/selecao-de-colaboradores.form.component';
import { ColaboradoresUploadLoteTableComponent } from './show/components/colaboradores-resultado-table/colaboradores-resultado-table.component';
import { HistoricoUploadComponent } from './show/components/historico-upload/historico-upload.component';

import { VisualizacaoPreviaUploadModalController } from './modals/visualizacao-previa-upload/visualizacao-previa-upload.modal.controller';
import { VisualizacaoPreviaUploadModalService } from './modals/visualizacao-previa-upload/visualizacao-previa-upload.modal.service';

import { UploadDocumentosEmLoteService } from './upload-documentos-em-lote.service';
import { UploadDocumentosEmLoteListRouting } from './upload-documentos-em-lote.routes';

export const UploadDocumentosEmLoteModule = angular.module('UploadDocumentosEmLoteModule', ['ui.router.state'])
    .controller('UploadDocumentosEmLoteIndexController', UploadDocumentosEmLoteIndexController)
    .controller('UploadDocumentosEmLoteNewController', UploadDocumentosEmLoteNewController)
    .controller('UploadDocumentosEmLoteShowController', UploadDocumentosEmLoteShowController)
    .controller('VisualizacaoPreviaUploadModalController', VisualizacaoPreviaUploadModalController)
    .service('UploadDocumentosEmLoteService', UploadDocumentosEmLoteService)
    .service('VisualizacaoPreviaUploadModalService', VisualizacaoPreviaUploadModalService)
    .component('dadosDoDocumentoFormComponent', DadosDoDocumentoFormComponent)
    .component('selecaoDeColaboradoresUploadLoteFormComponent', SelecaoDeColaboradoresUploadLoteFormComponent)
    .component('colaboradoresUploadLoteTableComponent', ColaboradoresUploadLoteTableComponent)
    .component('historicoUploadComponent', HistoricoUploadComponent)
    .config(UploadDocumentosEmLoteListRouting)
    .name;
